import { createContext } from 'react';

import { MenuContextValue } from './Menu.types';

export const MenuContext = createContext<MenuContextValue>({
    color: undefined,
    size: undefined,
    minWidth: undefined,
});
